define('presentation/signup/facades/signupPhoneNumberTypeFacade',[
        'businessServices/signup/signupSessionStore',
        'entities/signupNumberPortEntity',
        'externalDependencies/clientApi',
    ],
    function() {
        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        let _signupSessionStore = null;

        const SignupNumberPortEntityConstructor = require('entities/signupNumberPortEntity');

        const _clearPortForm = (numberPortId) => {
            const numberPortEntity = new SignupNumberPortEntityConstructor();
            numberPortEntity.numberPortId = numberPortId;
            numberPortEntity.phoneNumbersToPort = [];
            numberPortEntity.otherNumbersOnAccount = false;

            return _signupSessionStore.saveNumberPort(numberPortEntity);
        };

        const _cancelPhoneNumberReservation = (reservedPhoneNumber) => _signupSessionStore.cancelPhoneNumberReservation(reservedPhoneNumber);
        const _loadSignupSession = () => _signupSessionStore.get();
        const _saveNumberTypeSelection = (selectedCard) => _signupSessionStore.saveNumberTypeSelection(selectedCard);
        const _saveNumberIntentSelection = (numberIntentSelection) => _signupSessionStore.saveNumberIntentSelection(numberIntentSelection);
        const _setPhoneNumberCompleted = () => _signupSessionStore.setPhoneNumberCompleted(true);
        const _storeBypassNumberSelection = (isAgentBypass) => _signupSessionStore.storeBypassNumberSelection(isAgentBypass);

        const _init = () => {
            const SignupSessionStoreConstructor = require('businessServices/signup/signupSessionStore');
            _signupSessionStore = new SignupSessionStoreConstructor();
            _signupSessionStore.init();
        };

        return function() {
            let self = this;
            self.init = _init;
            self.clearPortForm = _clearPortForm;
            self.cancelPhoneNumberReservation = _cancelPhoneNumberReservation;
            self.loadSignupSession = _loadSignupSession;
            self.saveNumberTypeSelection = _saveNumberTypeSelection;
            self.saveNumberIntentSelection = _saveNumberIntentSelection;
            self.setPhoneNumberCompleted = _setPhoneNumberCompleted;
            self.storeBypassNumberSelection = _storeBypassNumberSelection;
        };
    });

